module.exports = __webpack_public_path__ + "static/scale-model-of-fullerton-california-ed1d4e9f70f40387fd4fa00317d35028.png";